module.exports = __webpack_public_path__ + "assets/img/product_complex@2x.62b9baed.jpg";